<pv-toolbar [title]="'briefing.title' | translate">
	@if ((loading$ | async) === false) {
		<ng-container class="right-actions">
			@if ((briefing$ | async).length === 0) {
				<a class="right-actions fa fa-times" data-test="close-button" (click)="close()"> </a>
			} @else {
				<a class="fa fa-check" data-test="close-button" (click)="confirm()"> </a>
			}
		</ng-container>
	}
</pv-toolbar>

@if (loading$ | async; as loading) {
	<loading-indicator [running]="loading" />
} @else {
	<ic-list-search-bar
		data-test="briefing-filter"
		filterConfirmRedirectUrl="/user-briefing"
		[hasActiveFilters]="hasActiveFilters$ | async"
		[page]="pageOption"
		(searchChange)="search($event)"
	/>

	<ic-briefing-list class="briefings content" [briefings]="briefing$ | async" />
}
